import React, { useEffect, useState } from "react"
import { ClickableVideo } from "../VideoLink/ClickableVideo"
import { Link } from "react-router"
import logo from "../assets/ecsenz_logo.svg"
import logoWhite from "../assets/ecsenz_logoWhite.svg"
import cartIcon from "../assets/cart.svg"
import contactIcon from "../assets/contact.svg"
import profileIcon from "../assets/profile.svg"
import waterVideo from "../assets/water.mp4"
import airqualityVideo from "../assets/airquality.mp4"

export function Header(): React.JSX.Element {
    const [scrolled, setScrolled] = useState(false)
    const [activeIndex, setActiveIndex] = useState<number | null>(null)
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [isMobile, setIsMobile] = useState(false)
    const [showMenuItems, setShowMenuItems] = useState(false)

    useEffect(() => {
        setShowMenuItems(true)

        const handleScroll = (): void => {
            setScrolled(window.scrollY > 0)
        }

        const handleResize = (): void => {
            setIsMobile(window.innerWidth < 1024)
            if (window.innerWidth >= 1024) {
                setMobileMenuOpen(false)
            }
        }

        handleResize()
        window.addEventListener("scroll", handleScroll)
        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("scroll", handleScroll)
            window.removeEventListener("resize", handleResize)
        }
    }, [])

    const showDarkTheme = scrolled || activeIndex !== null || mobileMenuOpen
    const textColor = showDarkTheme ? "#333" : "white"
    const hoverBgColor = showDarkTheme ? "#F2F2F2" : "rgba(255, 255, 255, 0.15)"

    return (
        <div>
            <header className={`header ${scrolled || mobileMenuOpen ? "header-scrolled" : ""}`}>
                <img
                    src={showDarkTheme ? logo : logoWhite}
                    style={{
                        position: "absolute",
                        left: isMobile ? "20px" : "48px",
                        height: isMobile ? "56px" : "72px",
                        width: "auto",
                    }}
                    alt="ecsenz logo"
                />

                {!isMobile && showMenuItems && menuItems.length > 0 && (
                    <div className="mega-menu">
                        <div className="menu-bar">
                            {menuItems.map((item, index) => (
                                // biome-ignore lint/a11y/noStaticElementInteractions: <explanation>
                                <div
                                    key={index}
                                    className="menu-item"
                                    style={{ color: textColor }}
                                    onMouseEnter={e => {
                                        setActiveIndex(index)
                                        e.currentTarget.style.backgroundColor = hoverBgColor
                                    }}
                                    onMouseLeave={e => {
                                        setActiveIndex(null)
                                        e.currentTarget.style.backgroundColor = "transparent"
                                    }}
                                >
                                    {item.title}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {!isMobile && (
                    <div
                        style={{
                            position: "absolute",
                            right: "48px",
                            display: "flex",
                            alignItems: "center",
                            gap: "32px",
                        }}
                    >
                        {showMenuItems && (
                            <div>
                                <Link
                                    to="/ecstore/allproducts"
                                    style={{
                                        color: textColor,
                                        fontWeight: "500",
                                        textDecoration: "none",
                                    }}
                                >
                                    Shop
                                </Link>
                            </div>
                        )}
                        {showMenuItems && (
                            <div>
                                <Link
                                    to="/ecstore/cart"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        textDecoration: "none",
                                    }}
                                >
                                    <img
                                        src={cartIcon}
                                        alt="Cart"
                                        style={{
                                            width: "24px",
                                            height: "24px",
                                            filter: showDarkTheme ? "none" : "brightness(0) invert(1)",
                                        }}
                                    />
                                </Link>
                            </div>
                        )}
                        <div>
                            <a
                                href="#contact"
                                style={{ display: "flex", alignItems: "center", gap: "6px", textDecoration: "none" }}
                            >
                                <img
                                    src={contactIcon}
                                    alt="Contact"
                                    style={{
                                        width: "32px",
                                        height: "32px",
                                        filter: showDarkTheme ? "none" : "brightness(0) invert(1)",
                                    }}
                                />
                            </a>
                        </div>
                        <Link to="https://test.internal.ecsenz.com/ecsenzwebapp/latest/#">
                            <button
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                }}
                            >
                                <img
                                    src={profileIcon}
                                    alt="Profile"
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        filter: showDarkTheme ? "none" : "brightness(0) invert(1)",
                                    }}
                                />
                            </button>
                        </Link>
                    </div>
                )}

                {isMobile && (
                    <div
                        style={{
                            position: "absolute",
                            right: "20px",
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                        }}
                    >
                        {showMenuItems && (
                            <Link to="/ecstore/cart">
                                <img
                                    src={cartIcon}
                                    alt="Cart"
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        filter: showDarkTheme ? "none" : "brightness(0) invert(1)",
                                    }}
                                />
                            </Link>
                        )}
                        {showMenuItems && (
                            <button
                                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: "8px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "5px",
                                }}
                            >
                                {/* biome-ignore lint/style/useSelfClosingElements: <explanation> */}
                                <span
                                    style={{
                                        width: "24px",
                                        height: "2px",
                                        backgroundColor: textColor,
                                        transition: "all 0.3s ease",
                                        transform: mobileMenuOpen ? "rotate(45deg) translateY(7px)" : "none",
                                    }}
                                ></span>
                                {/* biome-ignore lint/style/useSelfClosingElements: <explanation> */}
                                <span
                                    style={{
                                        width: "24px",
                                        height: "2px",
                                        backgroundColor: textColor,
                                        transition: "all 0.3s ease",
                                        opacity: mobileMenuOpen ? "0" : "1",
                                    }}
                                ></span>
                                {/* biome-ignore lint/style/useSelfClosingElements: <explanation> */}
                                <span
                                    style={{
                                        width: "24px",
                                        height: "2px",
                                        backgroundColor: textColor,
                                        transition: "all 0.3s ease",
                                        transform: mobileMenuOpen ? "rotate(-45deg) translateY(-7px)" : "none",
                                    }}
                                ></span>
                            </button>
                        )}
                    </div>
                )}
            </header>

            {!isMobile &&
                showMenuItems &&
                menuItems.length > 0 &&
                menuItems.map((item, index) => (
                    // biome-ignore lint/a11y/noStaticElementInteractions: <explanation>
                    <div
                        key={index}
                        className={`menu-content ${activeIndex === index ? "active" : ""}`}
                        onMouseEnter={() => setActiveIndex(index)}
                        onMouseLeave={() => setActiveIndex(null)}
                    >
                        {item.content}
                    </div>
                ))}

            {isMobile && showMenuItems && (
                <div
                    style={{
                        position: "fixed",
                        top: "56px",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "white",
                        transform: mobileMenuOpen ? "translateX(0)" : "translateX(100%)",
                        transition: "transform 0.3s ease-in-out",
                        overflowY: "auto",
                        zIndex: 999,
                        padding: "20px",
                    }}
                >
                    {menuItems.length > 0 &&
                        menuItems.map((item, index) => (
                            <div key={index} style={{ marginBottom: "24px" }}>
                                <div
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: "600",
                                        color: "#333",
                                        marginBottom: "16px",
                                        paddingBottom: "8px",
                                        borderBottom: "1px solid #eee",
                                    }}
                                >
                                    {item.title}
                                </div>
                                <div style={{ paddingLeft: "16px" }}>
                                    {/* biome-ignore lint/complexity/useOptionalChain: <explanation> */}
                                    {item.mobileLinks &&
                                        item.mobileLinks.map((link, linkIndex) => (
                                            <Link
                                                key={linkIndex}
                                                to={link.link}
                                                onClick={() => setMobileMenuOpen(false)}
                                                style={{
                                                    display: "block",
                                                    padding: "12px 0",
                                                    color: "#666",
                                                    textDecoration: "none",
                                                    fontSize: "15px",
                                                }}
                                            >
                                                {link.title}
                                            </Link>
                                        ))}
                                </div>
                            </div>
                        ))}
                    <div
                        style={{
                            marginTop: "32px",
                            paddingTop: "24px",
                            borderTop: "1px solid #eee",
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px",
                        }}
                    >
                        <Link
                            to="/ecstore/allproducts"
                            onClick={() => setMobileMenuOpen(false)}
                            style={{
                                color: "#333",
                                fontWeight: "500",
                                textDecoration: "none",
                                fontSize: "16px",
                            }}
                        >
                            Shop
                        </Link>
                        <Link
                            to="/#contact"
                            onClick={() => setMobileMenuOpen(false)}
                            style={{
                                color: "#333",
                                fontWeight: "500",
                                textDecoration: "none",
                                fontSize: "16px",
                            }}
                        >
                            Contact
                        </Link>
                    </div>
                </div>
            )}
        </div>
    )
}

interface MenuItemProps {
    title: string
    description: string
    videoSrc: string
    link: string
}

function MenuItem(props: MenuItemProps): React.JSX.Element {
    return (
        <div style={{ textAlign: "center", maxWidth: "320px" }}>
            <ClickableVideo videoSrc={props.videoSrc} link={props.link} />
            <div style={{ fontSize: "18px", fontWeight: "600", margin: "16px 0 8px 0" }}>{props.title}</div>
            <div style={{ fontSize: "14px", color: "#666", margin: "0 0 20px 0", lineHeight: "1.4" }}>
                {props.description}
            </div>
            <div style={{ display: "flex", gap: "24px", justifyContent: "center" }}>
                <Link
                    to={props.link}
                    style={{
                        textDecoration: "none",
                        color: "#333",
                        fontSize: "14px",
                        fontWeight: "500",
                        borderBottom: "1px solid #333",
                        paddingBottom: "2px",
                        transition: "all 0.2s ease",
                    }}
                    onMouseEnter={e => {
                        e.currentTarget.style.color = "#F485C7"
                        e.currentTarget.style.borderBottomColor = "#F485C7"
                    }}
                    onMouseLeave={e => {
                        e.currentTarget.style.color = "#333"
                        e.currentTarget.style.borderBottomColor = "#333"
                    }}
                >
                    Learn more
                </Link>
                {/** biome-ignore lint/a11y/noStaticElementInteractions: <explanation> */}
                <span
                    style={{
                        color: "#333",
                        fontSize: "14px",
                        fontWeight: "500",
                        borderBottom: "1px solid #333",
                        paddingBottom: "2px",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                    }}
                    onMouseEnter={e => {
                        e.currentTarget.style.color = "#F485C7"
                        e.currentTarget.style.borderBottomColor = "#F485C7"
                    }}
                    onMouseLeave={e => {
                        e.currentTarget.style.color = "#333"
                        e.currentTarget.style.borderBottomColor = "#333"
                    }}
                >
                    Configure
                </span>
            </div>
        </div>
    )
}

// Empty array - menu items are commented out
// const menuItems: Array<{
//     title: string
//     content: React.ReactNode
//     mobileLinks?: Array<{ title: string; link: string }>
// }> = []

const menuItems = [
    {
        title: "Measure",
        content: (
            <>
                <div style={{ display: "flex", gap: "40px" }}>
                    <MenuItem
                        title="Air Quality"
                        videoSrc="static/airquality.mp4"
                        description="Temperature, Humidity, Particulate Matter, CO2, VOC, NOX"
                        link="/ecstore/measure/air"
                    />
                    <MenuItem
                        title="Water"
                        videoSrc="static/water.mp4"
                        description="Temperature, Water Consumption"
                        link="/ecstore/measure/water"
                    />
                </div>
            </>
        ),
        mobileLinks: [
            { title: "Air Quality", link: "/ecstore/measure/air" },
            { title: "Water", link: "/ecstore/measure/water" },
        ],
    },
    {
        title: "Monitor",
        content: (
            <div style={{ display: "flex", gap: "40px" }}>
                <MenuItem
                    title="Assets"
                    videoSrc="static/airquality.mp4"
                    description="Switches, Position"
                    link="/ecstore/monitor/assets"
                />
                <MenuItem
                    title="Networks"
                    videoSrc="static/water.mp4"
                    description="Connectivity"
                    link="/ecstore/monitor/networks"
                />
                <MenuItem
                    title="Your Custom Device"
                    videoSrc="static/water.mp4"
                    description="Connectivity"
                    link="/ecstore/monitor/custom"
                />
            </div>
        ),
        mobileLinks: [
            { title: "Assets", link: "/ecstore/monitor/assets" },
            { title: "Networks", link: "/ecstore/monitor/networks" },
            { title: "Your Custom Device", link: "/ecstore/monitor/custom" },
        ],
    },
    {
        title: "Control",
        content: (
            <div style={{ display: "flex", gap: "40px" }}>
                <MenuItem
                    title="Fans"
                    videoSrc="static/airquality.mp4"
                    description="PWM, Modbus"
                    link="/ecstore/control/fans"
                />
                <MenuItem
                    title="Dampers"
                    videoSrc="static/water.mp4"
                    description="PWM, Modbus"
                    link="/ecstore/control/dampers"
                />
            </div>
        ),
        mobileLinks: [
            { title: "Fans", link: "/ecstore/control/fans" },
            { title: "Dampers", link: "/ecstore/control/dampers" },
        ],
    },
    {
        title: "Analyze",
        content: (
            <div style={{ display: "flex", gap: "40px" }}>
                <MenuItem title="Online" videoSrc={airqualityVideo} description="AI" link="/ecstore/analyze/online" />
                <MenuItem title="Excel" videoSrc={waterVideo} description="PWM, Modbus" link="/ecstore/analyze/excel" />
                <MenuItem
                    title="Origin"
                    videoSrc={waterVideo}
                    description="PWM, Modbus"
                    link="/ecstore/analyze/origin"
                />
                <MenuItem
                    title="Microsoft Graph"
                    videoSrc={waterVideo}
                    description="PWM, Modbus"
                    link="/ecstore/analyze/graph"
                />
                <MenuItem
                    title="Displays"
                    videoSrc={waterVideo}
                    description="PWM, Modbus"
                    link="/ecstore/analyze/displays"
                />
            </div>
        ),
        mobileLinks: [
            { title: "Online", link: "/ecstore/analyze/online" },
            { title: "Excel", link: "/ecstore/analyze/excel" },
            { title: "Origin", link: "/ecstore/analyze/origin" },
            { title: "Microsoft Graph", link: "/ecstore/analyze/graph" },
            { title: "Displays", link: "/ecstore/analyze/displays" },
        ],
    },
]